import { DateTime } from 'luxon'

import request from '../Components/Functions/ajax/request'

import NavbarStore from '../Stores/Navbar'

export default async function fetchNavbar ()
{
	(async function ()
	{
		try
		{
			var response = await request('/articles/get-navbar')
			.config({ })
			.post();
		}
		catch (update)
		{
			return;
		}

		setStore(response);
	})();
}

function setStore (response)
{
	if (!response) return;

	NavbarStore.update(function (store)
	{
		store.status = 'fetched';
		window.localStorage.setItem('navbar@status', store.status);

		store.date = DateTime.now().toUTC().toISO();
		window.localStorage.setItem('navbar@date', store.date);

		store.sub_families = Array.isArray(response.sub_families)
		? response.sub_families
		: [];

		window.localStorage
		.setItem('navbar@sub_families', JSON.stringify(store.sub_families));
	});
}